(() => {
  const root = document.querySelector('[data-ub-wishlist]');
  if (!root) return;
  const read = () => { try { const value=JSON.parse(localStorage.getItem('cfg:wishlist') || '[]'); return Array.isArray(value) ? value.map(String) : []; } catch { return []; } };
  let saved=read();
  function paint(){let count=0;root.querySelectorAll('[data-wish-product]').forEach(card=>{card.hidden=!saved.includes(card.dataset.wishProduct);if(!card.hidden)count++;});root.querySelector('[data-wish-empty]').hidden=count>0;}
  root.addEventListener('click',event=>{const button=event.target.closest('[data-wish-remove]');if(!button)return;saved=saved.filter(id=>id!==button.dataset.wishRemove);try{localStorage.setItem('cfg:wishlist',JSON.stringify(saved));}catch{}paint();});
  window.addEventListener('storage',()=>{saved=read();paint();});
  paint();
})();
